import { render, staticRenderFns } from "./SimpleModeDashboard.vue?vue&type=template&id=ddc8aa02&scoped=true&"
import script from "./SimpleModeDashboard.vue?vue&type=script&lang=ts&"
export * from "./SimpleModeDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleModeDashboard.vue?vue&type=style&index=0&id=ddc8aa02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc8aa02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddc8aa02')) {
      api.createRecord('ddc8aa02', component.options)
    } else {
      api.reload('ddc8aa02', component.options)
    }
    module.hot.accept("./SimpleModeDashboard.vue?vue&type=template&id=ddc8aa02&scoped=true&", function () {
      api.rerender('ddc8aa02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/simpleMode/SimpleModeDashboard.vue"
export default component.exports